export const MAX_SEARCH_RESULTS_PER_PAGE = 10;
